// Mock data for DressPay

// Helper to generate confirmation code
export const generateConfirmationCode = () => {
  return Math.floor(10000 + Math.random() * 90000).toString();
};

export const mockAdmin = {
  id: 'admin1',
  username: 'admin',
  password: 'admin123',
  email: 'admin@dresspay.com',
  role: 'admin',
  bankAccounts: [
    {
      id: 'bank1',
      accountName: 'DressPay Business',
      accountNumber: '****1234',
      bankName: 'Chase Bank',
      routingNumber: '****5678'
    }
  ]
};

export const mockCustomers = [
  {
    id: 'cust1',
    username: 'john_doe',
    password: 'password123',
    email: 'john@example.com',
    createdAt: '2024-01-15',
    status: 'active'
  },
  {
    id: 'cust2',
    username: 'jane_smith',
    password: 'password456',
    email: 'jane@example.com',
    createdAt: '2024-02-20',
    status: 'active'
  }
];

export const mockProducts = [
  // Fruits & Drinks ($1-20)
  {
    id: 'prod1',
    name: 'Fresh Orange Juice',
    category: 'Fruits & Drinks',
    price: 3.99,
    description: 'Freshly squeezed orange juice',
    image: 'https://images.unsplash.com/photo-1600271886742-f049cd451bba?w=400&h=400&fit=crop',
    stock: 50
  },
  {
    id: 'prod2',
    name: 'Organic Apples (5 pack)',
    category: 'Fruits & Drinks',
    price: 8.50,
    description: 'Fresh organic apples',
    image: 'https://images.unsplash.com/photo-1560806887-1e4cd0b6cbd6?w=400&h=400&fit=crop',
    stock: 100
  },
  {
    id: 'prod3',
    name: 'Strawberry Smoothie',
    category: 'Fruits & Drinks',
    price: 5.99,
    description: 'Delicious strawberry smoothie',
    image: 'https://images.unsplash.com/photo-1505252585461-04db1eb84625?w=400&h=400&fit=crop',
    stock: 30
  },
  {
    id: 'prod4',
    name: 'Banana Bundle (6 pack)',
    category: 'Fruits & Drinks',
    price: 4.50,
    description: 'Fresh bananas',
    image: 'https://images.unsplash.com/photo-1603833665858-e61d17a86224?w=400&h=400&fit=crop',
    stock: 80
  },
  {
    id: 'prod5',
    name: 'Green Tea Pack',
    category: 'Fruits & Drinks',
    price: 12.99,
    description: 'Premium green tea collection',
    image: 'https://images.unsplash.com/photo-1556679343-c7306c1976bc?w=400&h=400&fit=crop',
    stock: 40
  },
  {
    id: 'prod6',
    name: 'Mixed Berry Pack',
    category: 'Fruits & Drinks',
    price: 15.99,
    description: 'Fresh mixed berries',
    image: 'https://images.unsplash.com/photo-1498557850523-fd3d118b962e?w=400&h=400&fit=crop',
    stock: 25
  },
  // Toys & Baby Clothes ($20-60)
  {
    id: 'prod7',
    name: 'Teddy Bear Plush',
    category: 'Toys & Baby Clothes',
    price: 24.99,
    description: 'Soft and cuddly teddy bear',
    image: 'https://images.unsplash.com/photo-1530325553241-4f6e7690cf36?w=400&h=400&fit=crop',
    stock: 45
  },
  {
    id: 'prod8',
    name: 'Baby Onesie Set (3 pack)',
    category: 'Toys & Baby Clothes',
    price: 29.99,
    description: 'Adorable baby onesies',
    image: 'https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?w=400&h=400&fit=crop',
    stock: 60
  },
  {
    id: 'prod9',
    name: 'Building Blocks Set',
    category: 'Toys & Baby Clothes',
    price: 35.50,
    description: 'Colorful building blocks for kids',
    image: 'https://images.unsplash.com/photo-1558060370-d644479cb6f7?w=400&h=400&fit=crop',
    stock: 35
  },
  {
    id: 'prod10',
    name: 'Baby Romper',
    category: 'Toys & Baby Clothes',
    price: 38.99,
    description: 'Comfortable baby romper',
    image: 'https://images.unsplash.com/photo-1519238263530-99bdd11df2ea?w=400&h=400&fit=crop',
    stock: 50
  },
  {
    id: 'prod11',
    name: 'Educational Puzzle',
    category: 'Toys & Baby Clothes',
    price: 45.00,
    description: 'Fun educational puzzle',
    image: 'https://images.unsplash.com/photo-1587654780291-39c9404d746b?w=400&h=400&fit=crop',
    stock: 30
  },
  {
    id: 'prod12',
    name: 'Baby Sleepwear Set',
    category: 'Toys & Baby Clothes',
    price: 52.99,
    description: 'Cozy sleepwear for babies',
    image: 'https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?w=400&h=400&fit=crop',
    stock: 40
  },
  // Diapers ($60-70)
  {
    id: 'prod13',
    name: 'Premium Diapers (Size 1)',
    category: 'Diapers',
    price: 62.99,
    description: 'Premium quality diapers for newborns',
    image: 'https://images.unsplash.com/photo-1589478763880-61101367f6ce?w=400&h=400&fit=crop',
    stock: 100
  },
  {
    id: 'prod14',
    name: 'Eco Diapers (Size 2)',
    category: 'Diapers',
    price: 65.50,
    description: 'Eco-friendly diapers',
    image: 'https://images.unsplash.com/photo-1566663876697-2e3bb2e7a957?w=400&h=400&fit=crop',
    stock: 80
  },
  {
    id: 'prod15',
    name: 'Night Diapers (Size 3)',
    category: 'Diapers',
    price: 68.99,
    description: 'Extra absorbent night diapers',
    image: 'https://images.unsplash.com/photo-1587562144651-37cbd4d2f06e?w=400&h=400&fit=crop',
    stock: 70
  },
  // Men & Women Clothes ($70-130)
  {
    id: 'prod16',
    name: 'Classic White T-Shirt',
    category: 'Men & Women Clothes',
    price: 75.00,
    description: 'Premium cotton t-shirt',
    image: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=400&h=400&fit=crop',
    stock: 60
  },
  {
    id: 'prod17',
    name: 'Denim Jeans',
    category: 'Men & Women Clothes',
    price: 85.99,
    description: 'Stylish denim jeans',
    image: 'https://images.unsplash.com/photo-1542272604-787c3835535d?w=400&h=400&fit=crop',
    stock: 50
  },
  {
    id: 'prod18',
    name: 'Summer Dress',
    category: 'Men & Women Clothes',
    price: 92.50,
    description: 'Beautiful floral summer dress',
    image: 'https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=400&h=400&fit=crop',
    stock: 40
  },
  {
    id: 'prod19',
    name: 'Casual Blazer',
    category: 'Men & Women Clothes',
    price: 105.00,
    description: 'Smart casual blazer',
    image: 'https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=400&h=400&fit=crop',
    stock: 30
  },
  {
    id: 'prod20',
    name: 'Winter Coat',
    category: 'Men & Women Clothes',
    price: 118.99,
    description: 'Warm winter coat',
    image: 'https://images.unsplash.com/photo-1539533018447-63fcce2678e3?w=400&h=400&fit=crop',
    stock: 25
  },
  {
    id: 'prod21',
    name: 'Designer Hoodie',
    category: 'Men & Women Clothes',
    price: 125.00,
    description: 'Premium designer hoodie',
    image: 'https://images.unsplash.com/photo-1556821840-3a63f95609a7?w=400&h=400&fit=crop',
    stock: 35
  }
];

export const mockTransactions = [
  {
    id: 'trans1',
    confirmationCode: '45821',
    customerId: 'cust1',
    customerName: 'john_doe',
    date: '2024-03-15T10:30:00',
    items: [
      { productId: 'prod1', name: 'Fresh Orange Juice', price: 3.99, quantity: 2 },
      { productId: 'prod4', name: 'Banana Bundle', price: 4.50, quantity: 1 }
    ],
    total: 12.48,
    billLabel: 'Food',
    status: 'completed',
    paymentMethod: 'Credit Card (****1234)'
  },
  {
    id: 'trans2',
    confirmationCode: '73962',
    customerId: 'cust2',
    customerName: 'jane_smith',
    date: '2024-03-14T15:45:00',
    items: [
      { productId: 'prod16', name: 'Classic White T-Shirt', price: 75.00, quantity: 1 }
    ],
    total: 75.00,
    billLabel: 'Dress',
    status: 'completed',
    paymentMethod: 'Apple Pay'
  },
  {
    id: 'trans3',
    confirmationCode: '29184',
    customerId: 'cust1',
    customerName: 'john_doe',
    date: '2024-03-13T09:20:00',
    items: [
      { productId: 'prod7', name: 'Teddy Bear Plush', price: 24.99, quantity: 1 },
      { productId: 'prod8', name: 'Baby Onesie Set', price: 29.99, quantity: 1 }
    ],
    total: 54.98,
    billLabel: 'Toys',
    status: 'completed',
    paymentMethod: 'Debit Card (****5678)'
  }
];

// Helper function to get bill label based on category
export const getBillLabel = (category) => {
  const labelMap = {
    'Fruits & Drinks': 'Food',
    'Toys & Baby Clothes': 'Toys',
    'Diapers': 'Diapers',
    'Men & Women Clothes': 'Dress'
  };
  return labelMap[category] || 'Other';
};

// Helper function to filter products by amount
export const filterProductsByAmount = (amount) => {
  const numAmount = parseFloat(amount);
  if (isNaN(numAmount)) return [];
  
  // Find products within +/- $5 of the entered amount
  const matchingProducts = mockProducts.filter(product => {
    const diff = Math.abs(product.price - numAmount);
    return diff <= 5;
  });
  
  // Sort by exact match first, then by closest price
  return matchingProducts.sort((a, b) => {
    const diffA = Math.abs(a.price - numAmount);
    const diffB = Math.abs(b.price - numAmount);
    return diffA - diffB;
  });
};

// Stored transactions in localStorage
export const getStoredTransactions = () => {
  const stored = localStorage.getItem('dresspay_transactions');
  return stored ? JSON.parse(stored) : mockTransactions;
};

export const addTransaction = (transaction) => {
  const transactions = getStoredTransactions();
  transactions.unshift(transaction);
  localStorage.setItem('dresspay_transactions', JSON.stringify(transactions));
  return transaction;
};

// Get customers with updated passwords
export const getStoredCustomers = () => {
  const stored = localStorage.getItem('dresspay_customers');
  return stored ? JSON.parse(stored) : mockCustomers;
};

export const updateStoredCustomers = (customers) => {
  localStorage.setItem('dresspay_customers', JSON.stringify(customers));
};

// Get admin with updated credentials
export const getStoredAdmin = () => {
  const stored = localStorage.getItem('dresspay_admin');
  return stored ? JSON.parse(stored) : mockAdmin;
};

export const updateStoredAdmin = (admin) => {
  localStorage.setItem('dresspay_admin', JSON.stringify(admin));
};